<script lang="ts" setup>
import { inject, ref } from "vue";
import LoadingOverlay from "@/shared/components/LoadingOverlay.vue";
import { apiService } from "@/services/services";
import { Pool } from "@/models/pool.model";
import { usePool } from "@/features/pool/usePool";

const props = defineProps({
  ioType: {
    required: true,
    type: Number,
  },
  ioIndex: {
    required: true,
    type: Number,
  },
  defaultLabel: {
    required: false,
    type: String,
  },
});

const emit = defineEmits(["close"]);

const pool = usePool();
const renameValue = ref(
  pool.IORename.find(
    (ioRename) =>
      ioRename.ioIndex === props.ioIndex && ioRename.ioType === props.ioType
  )?.name ?? ""
);
const loading = ref(false);
const error = ref<any>(null);

const applyPoolChange = inject("applyPoolChange") as (
  fn: (pool: Pool) => Pool
) => void;

const save = () => {
  loading.value = true;

  apiService
    .renameIO({
      ioIndex: props.ioIndex,
      ioType: props.ioType,
      lang: "fr", //TODO depends on locale?
      newName: renameValue.value,
      poolID: pool.idSystem,
    })
    .then(
      () => {
        applyPoolChange((pool: Pool) => {
          const rename = pool.IORename?.find(
            (ioRename) =>
              ioRename.ioType === props.ioType &&
              ioRename.ioIndex === props.ioIndex
          );
          if (rename) {
            if (renameValue.value.length) {
              rename.name = renameValue.value;
            } else {
              pool.IORename = pool.IORename?.filter(
                (ioRename) => ioRename !== rename
              );
            }
          } else {
            pool.IORename?.push({
              ioIndex: props.ioIndex,
              ioType: props.ioType,
              name: renameValue.value,
            });
          }
          return pool;
        });
        emit("close");
      },
      (err) => {
        error.value = err;
      }
    )
    .finally(() => (loading.value = false));
};
</script>

<template>
  <div class="flex flex-col gap-3">
    <loading-overlay :loading="loading" :error="error" />
    <div class="form-label">{{ $t("NewName") }}</div>
    <input
      class="form-input"
      type="text"
      :placeholder="defaultLabel"
      autofocus
      v-model="renameValue"
    />
    <div class="btn--primary self-end" @click="save()">
      {{ $t("Save") }}
    </div>
  </div>
</template>
